import React from 'react';
import {
  Placeholder,
  ComponentRendering,
  ComponentParams,
  ComponentFactory,
  Field,
  SitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';
import { Grid } from '@mui/material';
import BackToTopButton from '../../BackToTopButton/BackToTopButton';

export type CartPageProps = {
  fields: {
    Heading: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

interface Props {
  children: React.ReactElement;
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
}

const CartPage = (props: Props): React.JSX.Element => {
  return (
    <Grid container spacing={0} className="cart-page-main">
      <Grid item xs={12} sm={12} md={12} lg={8} xl={8} sx={{ p: '8px' }}>
        <Placeholder name="page_cartloblistdetails" rendering={props.rendering} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={4} xl={4} sx={{ p: '8px' }}>
        <Placeholder name="page_ordersummary" rendering={props.rendering} />
      </Grid>
      <BackToTopButton />
    </Grid>
  );
};

export default CartPage;
